document.addEventListener("DOMContentLoaded", function () {

	//attempt to get the feedback form element
	let feedback_form = document.getElementById('lro-feedback-prompt');

	//if the feedback prompt exists and the user hasn't previously interacted with the prompt
	if(feedback_form && (document.cookie && !document.cookie.includes("lro_feedback_prompt=true"))) {

		//add the class to open the prompt
		feedback_form.classList.add('lro-feedback-prompt-open');

		//add the event listener to the various close buttons
		feedback_form.addEventListener('click', function (event) {

			// If the clicked element doesn't have the right selector, bail
			if (!event.target.matches('.ff-btn-submit') && !event.target.matches('.close-feedback-prompt')) return;

			//add the class to close the prompt
			feedback_form.classList.add('lro-feedback-prompt-close');

			//in 500ms
			setTimeout(function() {

				//add the cookie to prevent the prompt from showing again
				document.cookie = `lro_feedback_prompt=true; path=/; max-age=${60 * 60 * 24 * 14}`;

				//remove the prompt from the DOM
				feedback_form.remove();
			}, 500);
		}, false);
	}
});